import { render, staticRenderFns } from "./HighlightsSlider.vue?vue&type=template&id=4b46414e&scoped=true"
import script from "./HighlightsSlider.vue?vue&type=script&lang=js"
export * from "./HighlightsSlider.vue?vue&type=script&lang=js"
import style0 from "./HighlightsSlider.vue?vue&type=style&index=0&id=4b46414e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b46414e",
  null
  
)

export default component.exports